// extracted by mini-css-extract-plugin
export default {"container":"Table_container__YmQNy","cell":"Table_cell__tvGj6"};